<template>
  <div class="main web-content">
    <swiper :type="3" v-if="this.rootin == 'home'"></swiper>
    <div class="details">
      <el-button @click="goBack">返回</el-button>
      <h2>{{showData.title}}</h2>
      <p>{{showData.subtitle}}</p>
      <!-- <img :src="showData.image" alt />-->
      <pre class="content" v-html="showData.content"></pre>
    </div>
  </div>
</template>
<script>
import swiper from "../swiper";
export default {
  model: {
    prop: "show",
    event: "change"
  },
  props: {
    show: Boolean
  },
  components: {
    swiper
  },
  data() {
    return {
      showData: {},
      rootin:''
    };
  },
  created() {
    this.showData = this.$cache.get("showDynamic") || {};
    this.rootin = this.$cache.get("rootin") || {};
  },
  methods: {
    goBack() {
      if (this.rootin == 'home') {
        this.$router.go(-1);
      } else {
        this.$emit("change", false);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  .details {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    padding: 48px;
    position: relative;

    h2 {
      font-size: 30px;
      font-weight: 500;
      color: #333333;
    }
    p {
      font-size: 15px;
      color: #999999;
      margin: 16px 0 36px 0;
    }
    .content {
      word-break: break-all;
      font-size: 14px;
      font-weight: 400;
      color: #555555;
      line-height: 24px;
      white-space: pre-line;
    }
    .el-button {
      position: absolute;
      right: 48px;
    }
    img{
      width: 552px;
      height: 513px;
    }
  }
}
</style>


